import React from "react";
import "./assets/css/TemplateDesign.css";

const DataSequenceComponentLeft = (props) => {
  return (
    <div className="custom_text_full">
      <p dangerouslySetInnerHTML={{ __html: props.title }}></p>

      {/* <button
        className="btn btn-delete"
        onClick={() => props.parentDeleteDataSequence(props.id)}
      >
        Delete
      </button> */}
    </div>
  );
};

export default DataSequenceComponentLeft;
